import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

type Props = {
    skip: number;
    limit: number;
    search?: string | null;
    is_active?: boolean | undefined;
    start_date?: string | undefined;
    end_date?: string | undefined;
};

export const getAllStores = async (skip: number, limit: number, search?: string | null, is_active?: boolean | undefined, start_date?: string | undefined, end_date?: string | undefined) => {
    try {
        let url = `/store/list?skip=${skip}&limit=${limit}`;
        if (search) {
            url += `&search=${search}`;
        }
        if (is_active !== undefined) {
            url += `&is_active=${is_active}`;
        }
        if (start_date) {
            url += `&start_date=${start_date}`;
        }
        if (end_date) {
            url += `&end_date=${end_date}`;
        }

        const response = await Axios.get(url);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetAllStores = ({ skip, limit, search, is_active, start_date, end_date }: Props) => {
    const questions = useQuery({
        queryKey: ["get-all-stores", skip, limit, search, is_active, start_date, end_date],
        queryFn: () => getAllStores(skip, limit, search, is_active, start_date, end_date),
    });

    return questions;
};
